var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('exception-page',{style:(("min-height: " + _vm.minHeight)),attrs:{"home-route":"/demo","type":"500"}})}
var staticRenderFns = []

export { render, staticRenderFns }